<template>
    <b-container fluid class="acc-booking-view">
        <router-view/>
    </b-container>
</template>

<script>
    export default {
        name: 'AccBookingView'
    }
</script>
<style lang="less">
    .acc-booking-view {
        height: calc(100% - 110px);
    }
</style>